module.exports = __webpack_public_path__ + "static/img/pic5.c2b7039.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/universityHall/images/pic5.png
// module id = 4X2G
// module chunks = 0